export const DOMAIN_OPTIONS = [
  'Quantum Computing', 'BioTech', 'CleanTech', 'CyberSec',
  'AI / ML', 'HealthTech', 'FinTech', 'AgriTech',
  'EdTech', 'DeepTech', 'Manufacturing', 'Other'
] as const
export type DomainOption = typeof DOMAIN_OPTIONS[number]

export const STAGE_OPTIONS = [
  'Ideation', 'Disclosure', 'Patenting', 'Commercialisation', 'Scaling'
] as const
export type StageOption = typeof STAGE_OPTIONS[number]
